import { render, staticRenderFns } from "./CmgSingleEntreeMealBuilder.vue?vue&type=template&id=281b636e&scoped=true&lang=pug"
import script from "./cmg-single-entree-meal-builder.ts?vue&type=script&lang=ts&external"
export * from "./cmg-single-entree-meal-builder.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgSingleEntreeMealBuilder.vue?vue&type=style&index=0&id=281b636e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281b636e",
  null
  
)

export default component.exports